import { Chip } from "primereact/chip";
import { TEXT_SMALL } from "../../style";

export default function SelectedBatchesChips({ batches = [], onRemove, disabled = false }) {
    if (!batches.length) {
        return (
            <div className="mt-4 p-3 border-1 border-dashed border-gray-300 border-round">
                <p className={`${TEXT_SMALL} m-0 text-color-secondary`}>
                    No batches selected yet. Choose a branch, pick batches, then click Add Batches. Switch branches to add more.
                </p>
            </div>
        );
    }

    return (
        <div className="mt-4">
            <p className={`${TEXT_SMALL} m-0 mb-2 font-semibold`}>Selected batches ({batches.length})</p>
            <div className="flex flex-wrap gap-2 p-3 border-1 border-gray-300 border-round bg-gray-50">
                {batches.map((batch) => (
                    <Chip
                        key={batch.id}
                        label={`${batch.branch_title ? `${batch.branch_title}: ` : ""}${batch.title}`}
                        removable={!disabled}
                        onRemove={() => onRemove?.(batch.id)}
                    />
                ))}
            </div>
        </div>
    );
}
